import {
  getPushList,
  savePush,
  editPush,
  deletePush,
  findPush,
  findStatistics,
  recall,
  getAutoPushList
} from '@/axios/api/push'
import {
  getTrend,
  getFormulationList,
  getConsumerProduct,
  getInci,
  getBrandList,
  getBasfProduct,
  getConceptList,
  getEventList,
  getWebinar
} from '@/axios/api/appPictures'
import { Message } from 'element-ui'
import moment from 'moment'
const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_PARAMS = 'UPDATE_PARAMS'
const UPDATE_DET_LOADING = 'UPDATE_DET_LOADING'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_STATISTICS = 'UPDATE_STATISTICS'

const UPDATE_AUTO_TABLEDATA = 'UPDATE_AUTO_TABLEDATA'
const UPDATE_AUTO_TOTAL = 'UPDATE_AUTO_TOTAL'
const UPDATE_AUTO_PARAMS = 'UPDATE_AUTO_PARAMS'
const UPDATE_AUTO_SEARCH = 'UPDATE_AUTO_SEARCH'

const state = {
  tableData: [],
  tblLoading: false,
  detailLoading: false,
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  params: {
    title: '',
    sendStatus: '',
    creatorAccount: '',
    fromCreateTime: '',
    endCreateTime: '',
    fromSendTime: '',
    endSendTime: ''
  },
  detail: {},
  statistics: [],
  autoTableData: [],
  autoPager: {
    current: 1,
    size: 10,
    total: 0
  },
  autoParams: {
    fromSendTime: '',
    endSendTime: '',
    sendStatus: ''
  }
}

const getters = {
  tableData: state => state.tableData.map(v => {
    return {
      ...v,
      createTime: v.createTime ? moment(v.createTime * 1000).format('YYYY-MM-DD HH:mm:ss') : '',
      sendTime: v.sendTime ? moment(v.sendTime * 1000).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  }),
  tblLoading: state => state.tblLoading,
  pager: state => state.pager,
  params: state => state.params,
  detailLoading: state => state.detailLoading,
  detail: state => state.detail,
  statistics: state => state.statistics.map(v => {
    console.log((v.openCount / v.totalCount))
    return {
      ...v,
      clickedRate: (v.openCount / v.totalCount * 100).toFixed(2),
      receivedRate: (v.sentCount / v.totalCount * 100).toFixed(2)
    }
  }),
  autoTableData: state => state.autoTableData.map(v => {
    return {
      ...v,
      createTime: v.createTime ? moment(v.createTime * 1000).format('YYYY-MM-DD HH:mm:ss') : '',
      sendTime: v.sendTime ? moment(v.sendTime * 1000).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  }),
  autoPager: state => state.autoPager,
  autoParams: state => state.autoParams
}

const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_AUTO_TABLEDATA] (state, autoTableData) {
    state.autoTableData = autoTableData
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_AUTO_TOTAL] (state, total) {
    state.autoPager = { ...state.autoPager, total }
  },
  [UPDATE_PARAMS] (state, params) {
    state.params = { ...state.params, params }
  },
  [UPDATE_AUTO_PARAMS] (state, autoParams) {
    state.autoParams = autoParams
  },
  [UPDATE_DET_LOADING] (state, detailLoading) {
    state.detailLoading = detailLoading
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = { ...state.pager, ...pager }
    if (params) state.params = params
  },
  [UPDATE_AUTO_SEARCH] (state, { pager, params }) {
    state.autoPager = { ...state.autoPager, ...pager }
    if (params) state.autoParams = params
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_STATISTICS] (state, statistics) {
    state.statistics = statistics
  }
}

const actions = {
  // 获取列表数据
  async getTableDataApi ({commit}, params) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      let { data: res } = await getPushList(params)
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {}
    commit(UPDATE_TBL_LOADING, false)
  },
  // 获取auto列表数据
  async getAutoTableDataApi ({commit}, params) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      let { data: res } = await getAutoPushList(params)
      commit(UPDATE_AUTO_TABLEDATA, res.records)
      commit(UPDATE_AUTO_TOTAL, res.total)
    } catch (e) {}
    commit(UPDATE_TBL_LOADING, false)
  },
  // 设置筛选条件
  setParamsApi ({commit}, params) {
    commit(UPDATE_PARAMS, params)
  },
  // 设置auto筛选条件
  setAutoParamsApi ({commit}, params) {
    commit(UPDATE_AUTO_PARAMS, params)
  },
  // 保存订阅
  async savePushApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      await savePush(params)
      commit(UPDATE_DET_LOADING, false)
      Message.success('success')
      return true
    } catch (e) {
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  // 更新订阅
  async editPushApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      await editPush(params)
      Message.success('success')
      commit(UPDATE_DET_LOADING, false)
      return true
    } catch (e) {
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  // 清空搜索条件
  clearSearchApi ({state, commit}) {
    const pager = {
      ...state.pager,
      current: 1
    }
    const params = {}
    commit(UPDATE_SEARCH, { pager, params })
  },
  // 清空搜索条件
  clearAutoSearchApi ({state, commit}) {
    const pager = {
      ...state.autoPager,
      current: 1
    }
    const params = {}
    commit(UPDATE_AUTO_SEARCH, { pager, params })
  },
  // 设置page
  setPagerApi ({commit}, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  // 设置page
  setAutoPagerApi ({commit}, pager) {
    commit(UPDATE_AUTO_SEARCH, { pager })
  },
  // 删除订阅
  async deletePushApi ({commit}, params) {
    try {
      const res = await deletePush(params)
      return res.errorCode === 200
    } catch (e) {
      return false
    }
  },
  // 查看订阅详情
  async findPushApi ({commit}, params) {
    commit(UPDATE_DET_LOADING, true)
    try {
      const { data: res } = await findPush(params)
      const { countryIds, roleIds, userTypeIds, companyIds, departmentIds, specificUserList, fromRegisterTime, endRegisterTime, sendTime, isSendNow, linkPage } = res
      commit(UPDATE_DETAIL, {
        ...res,
        countryIds: countryIds ? countryIds.split(',').map(v => Number(v)) : [],
        roleIds: roleIds ? roleIds.split(',').map(v => Number(v)) : [],
        userTypeIds: userTypeIds ? userTypeIds.split(',').map(v => Number(v)) : [],
        companyIds: companyIds ? companyIds.split(',').map(v => Number(v)) : [],
        departmentIds: departmentIds ? departmentIds.split(',').map(v => Number(v)) : [],
        specificUserIds: specificUserList ? specificUserList.map(v => v.id) : [],
        registrationTime: fromRegisterTime && endRegisterTime ? [fromRegisterTime * 1000, endRegisterTime * 1000] : [],
        sendDate: (sendTime && !isSendNow) ? moment(sendTime * 1000).format('YYYY-MM-DD') : '',
        sendTime: (sendTime && !isSendNow) ? moment(sendTime * 1000).format('HH:mm') : '',
        linkPage: linkPage || ''
      })
      commit(UPDATE_DET_LOADING, false)
      return true
    } catch (e) {
      commit(UPDATE_DET_LOADING, false)
      return false
    }
  },
  // 获取各个模块二级下拉列表
  async getPageListApi ({commit}, { moduleId, keyword }) {
    try {
      const res = await getPageListFn[moduleId]({keyword})
      return res || []
    } catch (e) {
      return false
    }
  },
  // 查看统计信息
  async findStatisticsApi ({commit}, params) {
    try {
      const { data: res } = await findStatistics(params)
      commit(UPDATE_STATISTICS, res)
      return true
    } catch (e) {
      return false
    }
  },
  // 删除订阅
  async recallApi ({commit}, params) {
    try {
      const res = await recall(params)
      return res.errorCode === 200
    } catch (e) {
      return false
    }
  }
}
const getPageListFn = {
  612: async function (params) {
    try {
      const { data } = await getTrend(params)
      return data.map(value => {
        return {
          value: value.id,
          label: value.title
        }
      })
    } catch (e) {
      return []
    }
  },
  613: async function (params) {
    try {
      const { data } = await getBasfProduct({
        tradeName: params.keyword
      })
      return data.records.map(value => {
        return {
          value: value.id,
          label: value.tradeName
        }
      })
    } catch (e) {
      return []
    }
  },
  614: async function (params) {
    try {
      const { data } = await getFormulationList(params)
      return data.list.map(value => {
        return {
          value: value.id,
          label: value.title
        }
      })
    } catch (e) {
      return []
    }
  },
  615: async function (params) {
    try {
      const { data } = await getBrandList(params)
      return data.map(value => {
        return {
          value: value.id,
          label: value.name
        }
      })
    } catch (e) {
      return []
    }
  },
  616: async function (params) {
    try {
      const { data } = await getConsumerProduct(params)
      return data.list.map(value => {
        return {
          value: value.id,
          label: value.title
        }
      })
    } catch (e) {
      return []
    }
  },
  617: async function (params) {
    try {
      const { data } = await getInci({
        inciParam: params.keyword
      })
      return data.map(value => {
        return {
          value: value.id,
          label: value.inciName
        }
      })
    } catch (e) {
      return []
    }
  },
  619: async function (params) {
    try {
      const { data } = await getConceptList(params)
      return data.map(value => {
        return {
          value: value.id,
          label: value.internationalTitle
        }
      })
    } catch (e) {
      return []
    }
  },
  663: async function (params) {
    try {
      const { data } = await getWebinar(params)
      return data.map(value => {
        return {
          value: value.id,
          label: value.title
        }
      })
    } catch (e) {
      return []
    }
  },
  664: async function (params) {
    try {
      const { data } = await getEventList(params)
      return data.map(value => {
        return {
          value: value.id,
          label: value.eventName
        }
      })
    } catch (e) {
      return []
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/push.js